import {
  JourneyPaymentAuthorizationReplyData,
  PaymentMethod,
  PaymentRecord,
} from '@dapi/sdk';
import {
  createAmount,
} from '@dapi/sdk/spec';

export const alternatePaymentMethod: PaymentMethod = {
  paymentType: 'AlternativePaymentMethod'
};

export const paymentRecord: PaymentRecord = {
  id: 'BAGGAGECHARGEABLE',
  paymentTransactions: [
    {
      paymentMethod: alternatePaymentMethod,
      amount: createAmount({
        template: {
          value: 6000
        }
      })
    }
  ]
};

export const paymentRecordCheckout: PaymentRecord = {
  id: 'mock-ppid',
  paymentTransactions: [
    {
      paymentMethod: alternatePaymentMethod,
      amount: createAmount({
        template: {
          value: 6000
        }
      })
    }
  ]
};

export const authorization: JourneyPaymentAuthorizationReplyData = {
  merchantData: '',
  paymentAuthenticationRequest: '',
  termUrl: '',
  status: 'ok',
  url: '',
  paymentAction: 'confirm'
};
